import { type ShortlistsInitial } from '@/karehero-app/care/shortlists/ShortlistsTab';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// Every state the Shortlists V1 screen can be in, each paired with the
// `initial` props that drive the full screen there. Shared by the live state
// select (ShortlistsStage) and the handover spec (care-shortlists-v1.tsx), so
// the set of states stays defined in one place.
//
// Ids match the fixtures: shortlists 'residential-nursing' / 'dementia-specialists';
// providers 'oakwood' / 'riverside' / 'cherry-tree' / 'bramble'.
export const shortlistScenes: Scene<ShortlistsInitial>[] = [
  {
    id: 'home',
    label: 'Shortlist home',
    kind: 'happy',
    repro: 'The Search tab page: app bar, published shortlists, inert nav',
    initial: {},
  },
  {
    id: 'view-waiting',
    label: 'Published, nobody confirmed',
    kind: 'empty',
    // The first hours of every shortlist now: the request has gone out and no
    // provider has confirmed, so the list exists with nobody on it.
    repro:
      'Open ‘Home care in Edinburgh’ — published, no providers yet, waiting copy',
    initial: { shortlistId: 'awaiting-providers' },
  },
  {
    id: 'view',
    label: 'Shortlist view',
    kind: 'happy',
    repro: 'Open ‘Residential with nursing’ — all four provider statuses',
    initial: { shortlistId: 'residential-nursing' },
  },
  {
    id: 'drawer',
    label: 'Provider drawer',
    kind: 'happy',
    repro:
      'Open Riverside lodge — detail in a bottom sheet titled with the home',
    initial: { shortlistId: 'residential-nursing', providerId: 'riverside' },
  },
  {
    id: 'book',
    label: 'Book a visit',
    kind: 'happy',
    repro: 'Provider drawer with the book-a-visit sheet open',
    initial: {
      shortlistId: 'residential-nursing',
      providerId: 'riverside',
      booking: true,
    },
  },
  {
    id: 'home-empty',
    label: 'No shortlists yet',
    kind: 'empty',
    repro: 'Empty content, but the tab bar and app bar still show',
    initial: { empty: true },
  },
  {
    id: 'view-small',
    label: 'Small shortlist',
    kind: 'edge',
    repro: 'Dementia specialists: two providers, same layout',
    initial: { shortlistId: 'dementia-specialists' },
  },
  {
    id: 'drawer-unavailable',
    label: 'Unavailable provider',
    kind: 'edge',
    repro: 'Bramble court: muted, no Book a visit CTA',
    initial: { shortlistId: 'residential-nursing', providerId: 'bramble' },
  },
  {
    id: 'home-error',
    label: 'Failed to load',
    kind: 'error',
    repro: 'ErrorState in the tab page, tab bar and app bar still show',
    initial: { error: true },
  },
];

export const shortlistSceneById = makeSceneLookup(shortlistScenes);
